import { Text, Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { IconAutoStop } from '../../../../../icons'
import { messages } from '../messages'
import { styles } from '../styles'

type Props = {
  stop: boolean
}

export function StopAlert(props: Props) {
  const { stop } = props

  const { $t } = useIntl()

  if (stop) {
    return (
      <div data-testid="budget-stop-alert" className={styles.alertContainer}>
        <IconAutoStop />
        <Text tone="secondary">
          <FormattedMessage {...messages.stopAlert} />
        </Text>
      </div>
    )
  }

  return (
    <Tooltip text={$t(messages.tooltip)} placement="top">
      <div data-testid="budget-stop-tooltip" className={styles.iconContainer}>
        <IconAutoStop />
      </div>
    </Tooltip>
  )
}
